import { coursesApi } from "@services/apiMembersClient";
import {
  GetCertificateInput,
  GetCertificateOutput,
  UpdateCertificateInput,
  UpdateCertificateOutput,
} from "@_types/certificates";
import { AxiosPromise } from "axios";

export const getCertificate = ({ uuid }: GetCertificateInput): AxiosPromise<GetCertificateOutput> => {
  return coursesApi.get(`/courses/${uuid}/certificate`);
};

export const updateCertificate = ({ uuid, ...data }: UpdateCertificateInput): AxiosPromise<UpdateCertificateOutput> => {
  return coursesApi.patch(`/courses/${uuid}/certificate`, { ...data });
};
